@if (table(); as table) {
  <table class="agent-tool-result__table">
    <thead>
      <tr>
        @for (column of table.columns; track column.key) {
          @if (column.metricLabel) {
            <th>{{ column.label | translate: { metric: (column.metricLabel | translate) } }}</th>
          } @else {
            <th>{{ column.label | translate }}</th>
          }
        }
      </tr>
    </thead>
    <tbody>
      @for (row of table.rows; track $index) {
        <tr>
          @for (column of table.columns; track column.key) {
            @if (column.translated) {
              <td>{{ row[column.key] | translate }}</td>
            } @else {
              <td>{{ row[column.key] }}</td>
            }
          }
        </tr>
      }
    </tbody>
  </table>
  @if (table.truncated) {
    <div class="agent-tool-result__note">{{ "agent.result.more-rows" | translate: { count: table.total - table.rows.length } }}</div>
  }
  @if (table.truncatedUpstream) {
    <div class="agent-tool-result__note">{{ "agent.result.truncated-note" | translate }}</div>
  }
  @if (table.note) {
    <div class="agent-tool-result__note">{{ table.note | translate }}</div>
  }
  @if (table.coverageNote; as coverageNote) {
    <div class="agent-tool-result__note">{{ coverageNote.key | translate: coverageNote.params }}</div>
  }
}

@if (metrics(); as metrics) {
  <div class="agent-tool-result__metrics">
    @for (metric of metrics.metrics; track metric.label) {
      <div class="agent-tool-result__metric">
        <span class="agent-tool-result__metric-value">{{ metric.value }}</span>
        <span class="agent-tool-result__metric-label">{{ metric.label | translate }}</span>
        @if (metric.change) {
          <span class="agent-tool-result__metric-change">{{ "agent.result.change-vs-previous" | translate: { change: metric.change } }}</span>
        }
      </div>
    }
  </div>
  @if (metrics.note) {
    <div class="agent-tool-result__note">{{ metrics.note | translate }}</div>
  }
  @if (metrics.coverageNote; as coverageNote) {
    <div class="agent-tool-result__note">{{ coverageNote.key | translate: coverageNote.params }}</div>
  }
}

@if (chart(); as chart) {
  <div class="agent-tool-result__chart-title">{{ chart.metricLabel | translate }}</div>
  <div class="agent-tool-result__chart">
    <canvas baseChart [type]="'line'" [data]="chartData()" [options]="chartOptions()"></canvas>
  </div>
  @if (chart.note) {
    <div class="agent-tool-result__note">{{ chart.note | translate }}</div>
  }
}

@if (generic(); as generic) {
  <app-agent-tool-result-node [node]="generic.node"></app-agent-tool-result-node>
}

@if (sites(); as sites) {
  @for (site of sites.sites; track site.siteId) {
    <div class="agent-tool-result__site">
      <div class="agent-tool-result__site-title">{{ "agent.result.site" | translate: { id: site.siteId } }}</div>
      @if (site.view; as view) {
        <app-agent-tool-result [view]="view"></app-agent-tool-result>
      } @else if (site.errorKey) {
        <div class="agent-tool-result__site-error">{{ site.errorKey | translate }}</div>
      }
    </div>
  }
}
